import { Metadata, SocketConfig } from 'libs/collaboration/collaboration.types';
import { PageSize } from 'types/infographTypes';
import request from 'utils/request';

const BASE_PATH = '/api/design';

type FetchE2APITokenResponse = {
  message: string;
  token: string;
};
/**
 * Fetch JWT token using e1 infograph ID
 * @param e1InfographId
 * @returns {FetchE2APITokenResponse}
 */
export const fetchE2APITokenByInfographId = async (e1InfographId?: string) =>
  await request<FetchE2APITokenResponse>(`${BASE_PATH}/token`, {
    method: 'POST',
    body: JSON.stringify({ infograph_id: e1InfographId }),
  });

/**
 * Fetch JWT token using private link ID
 * @param privateLinkId
 * @returns {FetchE2APITokenResponse}
 */
export const fetchE2APITokenByPrivateLinkId = async (privateLinkId?: string) =>
  await request<FetchE2APITokenResponse>(`${BASE_PATH}/pl_token`, {
    method: 'POST',
    body: JSON.stringify({ privateLinkId }),
  });

export const fetchE2APITokenByPublicLinkId = async (publicLinkId?: string) =>
  await request<FetchE2APITokenResponse>(`${BASE_PATH}/pe_token`, {
    method: 'POST',
    body: JSON.stringify({ publicLinkId }),
  });

type GenerateThumbnailResponse = { message: string };
/**
 * Send the request to generate the new thumbnail using the e1 infograph ID
 * @param e1InfographId
 * @param size
 * @returns {GenerateThumbnailResponse}
 */
export const generateThumbnail = async (e1InfographId: string, size: PageSize) =>
  await request<GenerateThumbnailResponse>(`${BASE_PATH}/thumbnail`, {
    method: 'POST',
    body: JSON.stringify({
      id: e1InfographId,
      size,
    }),
  });

type FetchCollaborationConfigResponse = {
  message: string;
  payload: { multipage_metadata: Metadata; sockets: SocketConfig; team_share_enabled: boolean };
};
/**
 * Get the collaboration config to use the RTC feature
 * @param id e1 infograph ID
 * @returns {}
 */
export const fetchCollaborationConfig = async (id: string) =>
  await request<FetchCollaborationConfigResponse>(`${BASE_PATH}/rtc`, {
    method: 'POST',
    body: JSON.stringify({
      id,
    }),
  });
